import { Button, Col, FormGroup, Label } from 'reactstrap';
import { FeatureCode } from '@g17eco/core';
import { FeatureStability } from '@g17eco/molecules/feature-stability';
import { CustomReportTemplateType, Form } from './types';
import { PreviewBtn } from './PreviewBtn';
import { TEMPLATE_TYPE_LABEL } from '@g17eco/types/custom-report';

const ALL_OPTIONS: Array<{
  label: string;
  value: CustomReportTemplateType;
  icon: string;
  feature?: FeatureCode;
}> = [
  {
    label: TEMPLATE_TYPE_LABEL[CustomReportTemplateType.Default],
    value: CustomReportTemplateType.Default,
    icon: 'fa-table-columns',
  },
  {
    label: TEMPLATE_TYPE_LABEL[CustomReportTemplateType.Transposed],
    value: CustomReportTemplateType.Transposed,
    icon: 'fa-table-rows',
  },
  {
    label: TEMPLATE_TYPE_LABEL[CustomReportTemplateType.Tabular],
    value: CustomReportTemplateType.Tabular,
    icon: 'fa-table',
  },
  {
    label: TEMPLATE_TYPE_LABEL[CustomReportTemplateType.Normalised],
    value: CustomReportTemplateType.Normalised,
    icon: 'fa-arrow-down-short-wide',
    feature: FeatureCode.NormalisedReport,
  },
];

export const TemplateType = ({
  form,
  onChangeTemplateType,
  canAccessNormalisedReport,
}: {
  form: Form;
  onChangeTemplateType: (type: CustomReportTemplateType) => void;
  canAccessNormalisedReport: boolean;
}) => {
  const { templateType, columns } = form;
  const options = canAccessNormalisedReport
    ? ALL_OPTIONS
    : ALL_OPTIONS.filter((op) => op.value !== CustomReportTemplateType.Normalised);
  return (
    <>
      <FormGroup row className='mt-4'>
        <Label sm={2}>Template type*</Label>
        <Col sm={10}>
          <div className='d-flex align-items-stretch gap-2'>
            {options.map((op) => (
              <Button key={op.value} onClick={() => onChangeTemplateType(op.value)} active={templateType === op.value}>
                <i className={`fal ${op.icon} text-ThemeIconSecondary mr-1`} />
                {op.label}
                {op.feature ? <FeatureStability feature={op.feature} /> : null}
              </Button>
            ))}
            <PreviewBtn columns={columns} templateType={templateType} />
          </div>
        </Col>
      </FormGroup>
    </>
  );
};
